<div class="c-form-field c-form-field__confirm-code" [ngClass]="cssClass">
  <input
    *ngFor="let field of [].constructor(lengthCode); let i = index"
    [placeholder]="i + 1"
    type="number"
    (input)="onInput($event, i)"
    (focus)="onFocus($event, i)"
    disabled
    autofocus
  />
  <gtd-tooltip-component *ngIf="errorText" [data]="errorText"></gtd-tooltip-component>
</div>
